import Banner from "./Banner";
import type { BannerProps } from "./shared";

export default function DevBanner({
  hideSecondaryDismiss = true,
  testId = "dev-banner",
  ...props
}: Omit<BannerProps, "layout">) {
  return <Banner {...props} layout="full" hideSecondaryDismiss={hideSecondaryDismiss} testId={testId} />;
}
